import axios from "axios";

// Empty (the default) means same-origin: the Nginx in front of this app serves the
// SPA and proxies /api to the backend, so no cross-origin request — and no CORS —
// is involved. Set REACT_APP_BACKEND_URL only when the API lives on another origin.
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;
// withCredentials so the HttpOnly session cookie set by /api/auth/login travels
// with requests. Same-origin behind Nginx it would anyway; this keeps login
// working if REACT_APP_BACKEND_URL ever points at another origin (which then also
// needs that origin listed in the backend's CORS_ORIGINS).
export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).filter(Boolean).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
